import { useParams } from 'react-router-dom';
import SearchIcon from 'components/icons/search';
import Footer from 'components/Footer';
import useCustomSearchParams from 'hooks/useCustomSearchParams';
import ConversationsList from './ConversationsList';
import { SearchContainer, SearchInput, StyledCard } from './styled';
import FilterButton from './FilterButton';

const Page = () => {
    const { agentId = '' } = useParams();
    const [searchParams, setSearchParams] = useCustomSearchParams({
        search: {
            type: 'string',
            default: '',
        },
    });

    return (
        <>
            <StyledCard>
                <SearchContainer>
                    <SearchInput
                        type="search"
                        placeholder="Search conversation..."
                        variant="bare"
                        icon={<SearchIcon />}
                        borderRadius="semi-square"
                        value={searchParams.search}
                        onChange={(event) => setSearchParams({ search: event.target.value })}
                    />
                    <FilterButton label="Filters" agentId={agentId} />
                </SearchContainer>
                <ConversationsList />
            </StyledCard>
            <Footer />
        </>
    );
};

export default Page;
